import { createComponent } from '../utils';
import { useVStack } from './useVStack';
export default createComponent({
  useHook: useVStack,
  name: 'VStack'
});